import { useState } from 'react'
import { useAddFamilyMutation } from '../api/familyAPI'
import { addFamilyInput } from '../features/families/familySchema'
import { useNavigate } from 'react-router-dom'
import AddFamilyForm from './AddFamilyForm'

const AddFamilySection = () => {
  const [addFamily, { isLoading }] = useAddFamilyMutation()
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const navigate=useNavigate()

  const handleSubmit = async (data: addFamilyInput) => {
    setMessage('')
    setError('')
    try {
      const res = await addFamily(data).unwrap()
      setMessage(res.message||"משפחה נוספה בהצלחה")
      setTimeout(()=>navigate('/mentor-dashboard'),5000)
    } catch (err: any) {
      setError('הוספת משפחה נכשלה')
    }
  }

  return (
    <div className="p-4 bg-white rounded shadow-md max-w-xl mx-auto">
      <AddFamilyForm
        onSubmit={handleSubmit}
        isLoading={isLoading}
        message={message}
        error={error}
      />
    </div>
  )
}

export default AddFamilySection